export default class HistoryManager {
  static MAX_HISTORY_SIZE = 20;

  constructor() {
    this.history = [];
    this.currentIndex = -1;
    this.getStateCallback = null;
  }

  setGetStateCallback(callback) {
    this.getStateCallback = callback;
  }

  saveState() {
    if (this.getStateCallback) {
      const state = this.getStateCallback();
      if (state) {
        this.pushState(state);
      }
    }
  }

  pushState(state) {
    // Remove any states after current index (when undoing then making new changes)
    if (this.currentIndex < this.history.length - 1) {
      this.history = this.history.slice(0, this.currentIndex + 1);
    }

    // Add new state
    this.history.push(JSON.parse(JSON.stringify(state)));

    // Limit history size
    if (this.history.length > HistoryManager.MAX_HISTORY_SIZE) {
      this.history.shift();
    } else {
      this.currentIndex++;
    }

    this._dispatchStateChange();
  }

  canUndo() {
    return this.currentIndex > 0;
  }

  canRedo() {
    return this.currentIndex < this.history.length - 1;
  }

  undo() {
    if (!this.canUndo()) return null;

    this.currentIndex--;
    this._dispatchStateChange();

    return JSON.parse(JSON.stringify(this.history[this.currentIndex]));
  }

  redo() {
    if (!this.canRedo()) return null;

    this.currentIndex++;
    this._dispatchStateChange();
    return JSON.parse(JSON.stringify(this.history[this.currentIndex]));
  }

  _dispatchStateChange() {
    const event = new CustomEvent('promote:canvas--historyStateChanged', {
      detail: {
        canUndo: this.canUndo(),
        canRedo: this.canRedo()
      }
    });

    document.dispatchEvent(event);
  }
}
